import {connect} from 'react-redux';
import PersonalDataStepView from '../../../components/views/mx/creditoReal/PersonalDataStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {Catalog} from '../../../../common/types/common';
import {FormFieldProps} from '../../../../common/types/components';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import {State} from '../../../types/mx/reducers';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';
import {agesFromBirthday} from '../../../../common/utils/DateUtils';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import {rfcErrorSelector} from '../../../selectors/creditoReal/ui/loanApplication';
import {nationalitiesSelector} from '../../../selectors/creditoReal/applicantPersonal';

const mapStateToProps = (state: State, {match}) => {
    const receiveNewsPromotions = state.creditoReal.loanApplication.receiveNewsPromotions;
    const personal = state.creditoReal.loanApplication.applicantPersonal;
    const personalDataStepViewFieldErrorState = state.creditoReal.ui.personalDataStepView.fieldErrors;
    const summaryStepView = state.creditoReal.ui.summaryStepView;
    const crGenderCatalog = state.catalogs.crGender;
    const crCivilStatusCatalog = state.catalogs.crCivilStatus;
    const crStudiesLevelCatalog = state.catalogs.crStudiesLevel;
    const economicDependentsCatalog = Array.from({length: 11}, (_, i) => i).map(x => ({id: `${x}`, value: `${x}` }));
    return {
        personal,
        receiveNewsPromotions,
        crGenderCatalog,
        crCivilStatusCatalog,
        crStudiesLevelCatalog,
        economicDependentsCatalog,
        booleanOptions: MX_VALUES.BOOLEAN_VALUES,
        nationalities: nationalitiesSelector(state),
        firstNameField: new FormFieldProps(
            personal.firstName, personalDataStepViewFieldErrorState.firstNameFieldError
        ),
        secondNameField: new FormFieldProps(
            personal.secondName, personalDataStepViewFieldErrorState.secondNameFieldError
        ),
        lastNameField: new FormFieldProps(
            personal.lastName, personalDataStepViewFieldErrorState.lastNameFieldError
        ),
        secondLastNameField: new FormFieldProps(
            personal.secondLastName, personalDataStepViewFieldErrorState.secondLastNameFieldError
        ),
        birthDateField: new FormFieldProps(
            personal.birthDate, personalDataStepViewFieldErrorState.birthDateFieldError
        ),
        docNumberField: new FormFieldProps(
            personal.docNumber, personalDataStepViewFieldErrorState.docNumberFieldError
        ),
        cellPhoneField: new FormFieldProps(
            personal.cellPhone, personalDataStepViewFieldErrorState.cellPhoneFieldError
        ),
        personalDataFieldsHasError: WizardValidationUtils.hasErrorPersonalDataFields(
            personalDataStepViewFieldErrorState.firstNameFieldError,
            personalDataStepViewFieldErrorState.lastNameFieldError,
            personalDataStepViewFieldErrorState.secondLastNameFieldError,
            personalDataStepViewFieldErrorState.birthDateFieldError,
            personalDataStepViewFieldErrorState.docNumberFieldError,
            personalDataStepViewFieldErrorState.cellPhoneFieldError,
            personalDataStepViewFieldErrorState.genderFieldError,
            personalDataStepViewFieldErrorState.civilStatusFieldError,
            personalDataStepViewFieldErrorState.studiesLevelFieldError,
            personalDataStepViewFieldErrorState.economicDependentsFieldError,
            personalDataStepViewFieldErrorState.alreadyHasVehicleFieldError,
            personalDataStepViewFieldErrorState.nationalityFieldError,
        ),
        loanApplicationToken: match.params.token,
        returnToSummary: summaryStepView.returnToSummary,
        minAllowedAge: state.globalValidations.creditoReal.minAllowedAge,
        genderField: new FormFieldProps(
            personal.gender, personalDataStepViewFieldErrorState.genderFieldError
        ),
        civilStatusField: new FormFieldProps(
            personal.civilStatus,
            personalDataStepViewFieldErrorState.civilStatusFieldError
        ),
        studiesLevelField: new FormFieldProps(
            personal.studiesLevel,
            personalDataStepViewFieldErrorState.studiesLevelFieldError
        ),
        economicDependentsField: new FormFieldProps(
            personal.economicDependents, personalDataStepViewFieldErrorState.economicDependentsFieldError
        ),
        alreadyHasVehicleField: new FormFieldProps(
            personal.alreadyHasVehicle,
            personalDataStepViewFieldErrorState.alreadyHasVehicleFieldError
        ),
        nationalityField: new FormFieldProps(personal.nationality,
            personalDataStepViewFieldErrorState.nationalityFieldError),
        showRFCError: rfcErrorSelector(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeReceiveNewsPromotions: (receiveNewsPromotions) => {
            dispatch(WizardActions.CHANGE_RECEIVE_NEWS_PROMOTIONS_ACTION.action(receiveNewsPromotions));
        },
        onChangeFirstName: (firstName, error) => {
            dispatch(WizardActions.CHANGE_FIRST_NAME_ACTION.action(firstName, error));
        },
        onChangeSecondName: (secondName, error) => {
            dispatch(WizardActions.CHANGE_SECOND_NAME_ACTION.action(secondName, error));
        },
        onChangeLastName: (lastName, error) => dispatch(WizardActions.CHANGE_LAST_NAME_ACTION.action(lastName, error)),
        onChangeSecondLastName: (secondLastName, error) => {
            dispatch(WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.action(secondLastName, error));
        },
        onChangeBirthDate: (birthDate, error) => {
            dispatch(WizardActions.CHANGE_BIRTH_DATE_ACTION.action(birthDate, error));
        },
        onChangeDocNumber: (docNumber, error) => {
            dispatch(WizardActions.CHANGE_DOC_NUMBER_ACTION.action(docNumber, error));
        },
        onChangeCellPhone: (cellPhone, error) => {
            dispatch(WizardActions.CHANGE_CELL_PHONE_ACTION.action(cellPhone, error));
        },
        onChangeGender: (gender, error) => {
            dispatch(WizardActions.CHANGE_GENDER_ACTION.action(gender, error));
        },
        onChangeCivilStatus: (civilStatus, error) => {
            dispatch(WizardActions.CHANGE_CIVIL_STATUS_ACTION.action(civilStatus, error));
        },
        onChangeStudiesLevel: (studiesLevel, error) => {
            dispatch(WizardActions.CHANGE_STUDIES_ACTION.action(studiesLevel, error));
        },
        onChangeEconomicDependents: (economicDependents, error) => {
            dispatch(WizardActions.CHANGE_ECONOMIC_DEPENDENTS_ACTION.action(economicDependents, error));
        },
        onChangeAlreadyHasVehicle: (alreadyHasVehicle, error) => {
            dispatch(WizardActions.CHANGE_ALREADY_HAS_VEHICLE_ACTION.action(alreadyHasVehicle, error));
        },
        onChangeNationality: (nationality: Catalog, error: string) =>
            dispatch(WizardActions.CHANGE_NATIONALITY_ACTION.action(nationality, error)),
        onPressNext: personal => () => {
            const dataLaterData = {
                age: agesFromBirthday(personal.birthDate)
            };
            pushDataLayer(DATA_LAYER.APPLICANT, dataLaterData);
            dispatch(WizardMXActions.SAVE_APPLICANT_DATA_MX_ACTION.action());
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action()),
        getLoanApplication: token => () => {
            if (token) {
                dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token));
            } else {
                dispatch(WizardMXActions.VERIFY_CALCULATOR_DATA.action());
            }
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(stateProps.loanApplicationToken),
        onPressNext: dispatchProps.onPressNext(stateProps.personal)
    };
};

const PersonalDataStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PersonalDataStepView));

export default PersonalDataStepContainer;
